angular.module( 'acme.view.application.membership.benefits.modals.remove', [
  'ui.router',
  'ui.bootstrap',
  'acme.view.application.membership.benefits.modals.remove.controllers'
])

.config(function config( $stateProvider ) {

  // Create both abstract view and template view.
  // Abstract Views are enabled by default
  var membershipBenefitsModalsRemove = {
        name: 'application.membership.benefits.modals.remove',
        url: '/membership/benefits/modals/remove',
        views: {
          "main": {
            controller: 'MembershipBenefitsModalsRemoveController',
            // Assumes the view is entirely self contained
            templateUrl: 'views/application/views/membership/benefits/modals/remove/remove.tpl.html'
          }
        },
        data: {
          pageTitle: '    ',
          /** Secure With Permissions **/
          permissions: []
        }
      };

    $stateProvider
      .state(membershipBenefitsModalsRemove);
});
